import { useRegisterSW } from "virtual:pwa-register/react";

const CHECK_EVERY_MS = 60 * 60 * 1000;

/**
 * Avisa cuando hay una version nueva desplegada en vez de recargar sola: una
 * recarga automatica en mitad de una nota se llevaria lo escrito.
 *
 * El navegador solo busca un service worker nuevo al navegar, y la app
 * instalada puede pasar dias abierta sin hacerlo. Por eso se comprueba cada
 * hora y cada vez que la app vuelve a primer plano.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const check = () => {
        if (navigator.onLine) void registration.update();
      };
      setInterval(check, CHECK_EVERY_MS);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") check();
      });
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="update-prompt" role="status">
      <span>Hay una versión nueva</span>
      <span className="spacer" />
      <button
        className="btn btn--quiet"
        onClick={() => setNeedRefresh(false)}
      >
        Luego
      </button>
      <button
        className="btn update-prompt__action"
        onClick={() => void updateServiceWorker(true)}
      >
        Recargar
      </button>
    </div>
  );
}
